import { render, staticRenderFns } from "./Sumit.vue?vue&type=template&id=40110f28&"
import script from "./Sumit.vue?vue&type=script&lang=js&"
export * from "./Sumit.vue?vue&type=script&lang=js&"
import style0 from "./Sumit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports